import {TaskEvent} from "@core/model";
import {Stack} from "@mui/material";
import {CalendarProps, ViewStatic} from "react-big-calendar";
import {Agenda} from "./Agenda";
import {useDownBreakpoint} from "@hooks";

// @ts-expect-error - React big calendar typescript definitions are wrong
const AgendaView: React.FC & ViewStatic = (props: CalendarProps<TaskEvent>) => {
  const {events} = props;
  const isDownSm = useDownBreakpoint("sm");

  return (
    <Stack spacing={0.5} flex={"1 1 0"} overflow={"auto"}>
      <Agenda events={events} minimize={isDownSm} />
    </Stack>
  );
};

AgendaView.navigate = (date: Date, action: string) => {
  switch (action) {
    case "PREV":
      return new Date(date.getFullYear(), date.getMonth() - 1, 1);
    case "NEXT":
      return new Date(date.getFullYear(), date.getMonth() + 1, 1);
    default:
      return date;
  }
};

AgendaView.title = () => "";

// @ts-expect-error - React big calendar typescript definitions are wrong
AgendaView.range = (date: Date) => {
  const start = new Date(date.getFullYear(), date.getMonth(), 1);
  const end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  return [start, end];
};

export {AgendaView};
